if(!customElements.get('text-lens-zoom')) {
    customElements.define('text-lens-zoom', class TextLensZoom extends StickyScroll {
        // opacity 和 scale 均通过 CSS calc(var(--change-ratio)) 驱动
        // 无需额外的 JS 样式写入，父类 handleScrollEffect 已更新 --change-ratio
    });
}
